import { render, staticRenderFns } from "./EditTemplateSection.vue?vue&type=template&id=3a5e47c2&scoped=true"
import script from "./EditTemplateSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTemplateSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditTemplateSection.vue?vue&type=style&index=0&id=3a5e47c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e47c2",
  null
  
)

export default component.exports